export const normalizeTenantId = (tenantId: string | null | undefined): string => {
  const normalizedValue = String(tenantId ?? '').trim();

  if (!normalizedValue || normalizedValue === 'undefined' || normalizedValue === 'null')
    return '';

  return normalizedValue.toUpperCase();
};